import React from 'react'
import { FastField } from 'formik'

const days = [
	'Monday',
	'Tuesday',
	'Wednesday',
	'Thursday',
	'Friday',
	'Saturday',
	'Sunday',
];

export default
class Hours extends React.Component {
	render() {
		const { field, isEditing, ...props } = this.props;

		return (
			<div className='Hours'>
				{ field.value.map((v, i) => (
					<div key={i} className="Hours-day">
						<div className="Hours-dayLabel">{days[i]}</div>
						<FastField {...props} name={`${field.name}.${i}`} type="number" placeholder="0" />
					</div>
				))}
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/modules/form/components/input/Hours.jsx